import React from "react";
import {useHistory} from "react-router-dom";
import axios from "../../../utils/apiClient";
import {IMPERSONATION_KEY, useAuth} from "../../../context/authContext";
import {SessionStorageUtil} from "../../../utils/localStorageUtil";

const componentName = "Account";

const Account = () => {
  const auth = useAuth();
  const history = useHistory();

  const handleExitImpersonateUserClick = async (targetUsername, impersonatorUsername) => {
    try {
      await exitImpersonation(targetUsername, impersonatorUsername);
    } catch (e) {
        console.error(e);
    }
  };
  
  async function exitImpersonation(targetUsername, impersonatorUsername) {
    const params = new URLSearchParams();
    params.append('targetUsername', targetUsername);
    params.append('impersonationActive', 'false');
    params.append('impersonatorUsername', impersonatorUsername);
    SessionStorageUtil.removeObj(IMPERSONATION_KEY);

    try {
      await axios.post(
        `${process.env.REACT_APP_REST_API_BASE_URL}/v1/impersonate/exit`,
        params
      );

      window.location.href = "/all_patients";
    } catch (error) {
      console.error("Error exiting impersonation:", error);
    }
  }

  return (
    <div id={`${componentName}-account`} className="btn-group">
        <button id={`${componentName}-accountIcon`} type="button" className="btn btn-link dropdown-toggle border-0" data-bs-toggle="dropdown" aria-expanded="false">
          <i className="fa-regular fa-user border-0 text-dark"></i>
        </button>
        <ul id={`${componentName}-accountDropdown`} className="dropdown-menu dropdown-menu-end">
          <li>
            <button id={`${componentName}-accountSettings`} className="dropdown-item" onClick={() => history.push({pathname:"/settings", state:{pageTitle:"Account Settings"}})}>
              Account
            </button>
          </li>
          {SessionStorageUtil.getObj(IMPERSONATION_KEY) ? (
            <li>
              <button className="dropdown-item" id={`${componentName}-exitImpersonateUserButton`} type="button" onClick={() => handleExitImpersonateUserClick(auth.getImpersonationTargetUsername(), auth.getUsername())}>
                Exit Impersonation
              </button>
            </li>
          ) : (
            <li>
              <button className="dropdown-item" id={`${componentName}-accountLogout`} type="button" onClick={() => auth.logout()}>
                Sign Out
              </button>
            </li>
          )}
          <li><hr className="dropdown-divider" /></li>
          <li id={`${componentName}-loggedInAs`}>
            <h6 className="dropdown-header">
                {
                    auth.userImpersonationActive() ? "Impersonating as " + (auth.getImpersonationTargetUsername() ? auth.getImpersonationTargetUsername() : "Unknown User" ) : "You are logged in as " + auth.getUsername()
                }
            </h6>
          </li>
        </ul>
    </div>
  );
};

export default Account;
